import { UntypedFormControl, UntypedFormArray } from '@angular/forms';

export class CustomField {
  label: UntypedFormControl;
  value: UntypedFormArray;
}
